import { useT } from "../hooks/useT";
import { useEffect, useRef } from "react";

export default function VisionSection() {
  const t = useT();
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("visible"); }),
      { threshold: 0.1 }
    );
    ref.current?.querySelectorAll(".fade-in, .clip-reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="vision" ref={ref} className="bg-[#0a0a0a] py-32 md:py-44 relative border-b" style={{ borderColor: 'var(--rule)' }}>
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="max-w-[760px]">
          <div className="fade-in">
            <h2 className="clip-reveal font-serif text-3xl md:text-5xl tracking-[0.06em] text-[var(--text-primary)] mb-16 md:mb-20 leading-tight" style={{ fontWeight: 300 }}>
              {t.vision.heading}
            </h2>

            <div className="space-y-8 md:space-y-10">
              <p className="font-sans text-[15px] md:text-[16px] text-[var(--text-secondary)] leading-[1.8]">
                {t.vision.p1}
              </p>
              <p className="font-sans text-[15px] md:text-[16px] text-[var(--text-secondary)] leading-[1.8]">
                {t.vision.p2}
              </p>
              <p className="font-sans text-[15px] md:text-[16px] text-[var(--text-secondary)] leading-[1.8]">
                {t.vision.p3}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
